// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

type MutationOptions = {
  variables: {
    input: {
      notes?: string,
    },
  },
  uploadables: Object,
};

const mutation = graphql`
  mutation UploadCustomerPOMutation($input: UploadCustomerPOInput!) {
    uploadCustomerPO(input: $input) {
      poUpload {
        poUploadId
        fileName
        fileUrl
        status
        errorMessage
        extractedData
        createdAt
      }
    }
  }
`;

export default {
  commit: (options: MutationOptions) => {
    return createRelayMutation(mutation, options);
  },
};
